export enum PageType {
  Referral = 'referral',
  Consent = 'consent',
  Bind = 'bind',
  Confirm = 'confirm',
  Static = 'static',
}
